import React from 'react'

import {Loader} from './Loader'

export const MainLoader: React.FC = () => <Loader height="60vh" />
